import projectsStyle from '../projectsStyle'

import {
  garamond,
  haylardDisplay,
  title,
  italicSubTitle,
  greyButton,
  greyButtonHoverDark
} from "../../../style/style.jsx";

import colors from "../../../style/colors.scss";


const projectPageStyle = theme => ({
  ...projectsStyle(theme),
  heroContainer: {
    width: '100%',
    height: 'calc(100% - 64px)',
    minHeight: '680px',
    marginTop: '64px',
    color: 'black',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 250px)'
    }
  },
  heroContainerPreview: {
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  circleContainer: {
    padding: '40px',
    [theme.breakpoints.down('md')]: {
      padding: '5px',
      paddingBottom: '20px'
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
      paddingBottom: '20px'
    }
  },
  title: {
    ...title,
    textAlign: 'center',
    fontSize: '24px',
  },
  addressCity: {
    ...title,
    textAlign: 'center',
    fontSize: '18px',
  },
  address: {
    textAlign: 'center',
    lineHeight: '1.2',
    ...garamond,
    fontStyle: 'italic',
    fontSize: '18px'
  },
  border: {
    width: '20%',
    borderBottom: '1px solid ' + colors.darkGrey,
    marginTop: '50px',
    marginBottom: '20px'
  },
  borderCarousel: {
    width: '10%',
    borderBottom: '1px solid ' + colors.darkGrey,
    marginTop: '20px',
    marginBottom: '20px'
  },
  priceCircle: {
    ...haylardDisplay,
    border: '1px solid ' + colors.grey,
    height: '80px',
    width: '80px',
    borderRadius: '45px',
    textAlign: 'center',
    fontSize: '14px',
    wordBreak: 'break-all',
    [theme.breakpoints.down('md')]: {
      height: '70px',
      width: '70px'
    },
    [theme.breakpoints.down('sm')]: {
      height: '80px',
      width: '80px'
    }
  },
  subTitleCircle: {
    ...garamond,
    fontStyle: 'italic',
    fontSize: '18px',
    color: colors.grey,
    textAlign: 'center',
    marginBottom: '10px',
    textTransform: 'capitalize',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px'
    }
  },
  infoContainer: {
    position: 'absolute',
    bottom: '0',
    background: colors.lightGrey2,
    zIndex: '1',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      height: '100%',
      padding: '20px 0px'
    }
  },
  infoSectionContainer: {
    padding: '0px 50px',
    marginTop: '20px',
    marginBottom: '20px',
    borderRight: '1px solid ' + colors.grey,
    alignContent: 'flex-start',
    [theme.breakpoints.down('lg')]: {
      marginTop: '5px',
      marginBottom: '5px',
      padding: '20px 30px'
    },
    [theme.breakpoints.down('md')]: {
      padding: '0px 10px'
    },
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      padding: '0px 18px'
    }
  },
  infoBoxSectionContainer: {
    padding: '0px 30px',
    alignContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      marginTop: '20px',
      marginBottom: '20px',
    }
  },
  lastSection: {
    borderRight: 'none'
  },
  appointment: {
    height: '150px',
    background: colors.lightGrey3,
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      position: 'sticky',
      top: 'calc(100vh - 50px)',
      zIndex: '1',
      background: 'transparent'
    }
  },
  boxInfo: {
    background: 'white',
    padding: '0px 20px',
    border: '1px solid black',
    width: 'initial',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
      width: '100%',
      borderTop: '1px solid black',
      borderBottom: '1px solid black',
      border: 'none'
    }
  },
  subTitleInfo: {
    ...garamond,
    fontStyle: 'italic',
    fontSize: '18px',
    color: colors.grey,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      letterSpacing: '1px'
    },
    "h1 &": {
      fontWeight: 'normal',
      lineHeight: '26.1px'
    },
    "h2 &": {
      fontWeight: 'normal',
      lineHeight: '26.1px'
    }
  },
  carouselContainer: {
    margin: '100px 0px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
    }
  },
  planContainer: {
    margin: '100px 0px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
      marginBottom: '50px'
    }
  },
  infoContainerCarousel: {
    padding: '200px 120px 100px 120px',
    color: 'black',
    [theme.breakpoints.down('md')]: {
      padding: '80px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '50px 20px'
    }
  },
  titleCarousel: {
    ...title,
    fontSize: '18px',
    marginBottom: '20px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      borderTop: `2px solid #cecece`,
      paddingTop: '50px'
    }
  },
  subTitleCarousel: {
    ...italicSubTitle,
    fontSize: '20px',
    textAlign: 'center',
    letterSpacing: '1px'
  },
  description: {
    ...garamond,
    textAlign: 'center',
    margin: '20px',
  },
  logoBoxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0 45px 0',
      height: 'auto'
    }
  },
  logo: {
    height: '100%',
    width: '100%',
    maxHeight: '80%',
    minWidth: '250px',
    maxWidth: '55%',
    objectFit: 'contain',
    margin: '0',
    [theme.breakpoints.down('md')]: {
      minWidth: 'unset',
      maxWidth: '85%'
    },
  },
  logoMobile:{
    height: '100%',
    width: '100%',
    maxHeight: '180px', 
    maxWidth: '200px',
    objectFit: 'contain',
    margin: 0,
  },
  otherRes: {
    margin: '50px 0px',
    [theme.breakpoints.down('sm')]: {
      margin: '20px 0px'
    }
  },
  backgroundImageHero: {
    width: '100%',
    backgroundSize: 'cover',
    transition: 'transform .5s ease',
    display: 'block',
    height: '100%',
    '&:hover': {
      transform: 'scale(1.05)'
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%'
    }
  },
  videoContainer: {
    margin: '100px 50px 50px 50px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px 20px 0px'
    }
  },
  videoPlayerContainer:{
    width: '80%',
    [theme.breakpoints.up('lg')]: {
      width: '70%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  greyButtonDark: {
    ...greyButton,
    '&:hover': {
      ...greyButtonHoverDark
    }
  },
  divider:{
    backgroundColor: '#cecece',
    width: '100%',
    height: '2px'
  },
  siteButtonContainer:{
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
    }
  },
  letterBackground: {
    display: 'flex',
    alignItems: 'center',
    position: "absolute",
    right: "-275px",
    width: "275px",
    zIndex: "-1",

    '& > img': {
      margin: '0',
    },

    [theme.breakpoints.down('md')] : {
        display: "none"
    }
  },
  resCardsContainer: {
    [theme.breakpoints.down('lg')]: {
      padding: '24px 50px 100px 50px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      margin: '10px 0 50px 0',
    },
  },
});

export default projectPageStyle;